import DaysToExclude from "../../../api/Randoms/GovPoolModel/DaysToExclude"
import { FormatShortDate } from "../../../formatters/FormatDate"
import { parseISO } from "date-fns"

export interface DatesToExcludeProps {
  daysToExclude: DaysToExclude[]
}

const DatesToExclude = (props: DatesToExcludeProps) => {
  const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime()
  // Remove past dates
  const daysToExclude = props.daysToExclude.filter(item => item.DayOfWeekID || (item.DateExclude && parseISO(item.DateExclude)?.getTime() >= today))

  const toExclude = (daysToExclude: DaysToExclude[]) => {
    return daysToExclude
      .filter(item => item.DateExclude)
      .map(item => parseISO(item.DateExclude || ""))
      .sort((a, b) => a.getTime() - b.getTime())
      .map(date => FormatShortDate(date!, true))
  }

  const datesToExclude = toExclude(daysToExclude)

  return (
    <>
      {datesToExclude.map((date, index) =>
        <div key={date.replace(' ', '_')} className="float-left text-nowrap pt-2 pr-2">
          {index < datesToExclude.length - 1 ? `${date},` : `${date}`}
        </div>
      )}
    </>
  )
}

export default DatesToExclude
